import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade | Dr. Kelson Kawamura" },
      {
        name: "description",
        content:
          "Política de Privacidade do site do Dr. Kelson Kawamura, em conformidade com a LGPD (Lei nº 13.709/2018).",
      },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Política de Privacidade | Dr. Kelson Kawamura" },
      {
        property: "og:description",
        content:
          "Política de Privacidade do site do Dr. Kelson Kawamura, em conformidade com a LGPD.",
      },
      { property: "og:url", content: "https://cirurgiaplasticafoz.com.br/politica-de-privacidade" },
    ],
    links: [{ rel: "canonical", href: "https://cirurgiaplasticafoz.com.br/politica-de-privacidade" }],
  }),
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  const updated = "15 de junho de 2026";
  return (
    <>
      <Header />
      <main>
        <div className="kk-section">
          <div className="kk-container" style={{ maxWidth: 820, margin: "0 auto" }}>
        <span className="kk-eyebrow">Documento legal</span>
        <h1 className="kk-h1" style={{ marginTop: 12 }}>Política de Privacidade</h1>
        <hr className="kk-divider" style={{ margin: "16px 0 24px" }} />
        <p className="kk-lead" style={{ marginBottom: 28 }}>
          Esta Política descreve como tratamos os dados pessoais coletados neste site, em
          conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).
        </p>

        <h2 className="kk-h2">1. Controlador dos dados</h2>
        <p>
          O controlador é <strong>Kawamura Cirurgia Plastica LTDA</strong> — Nome fantasia: Kawamura Cirurgia Plastica, CNPJ 37.941.107/0001-44, representada pelo Dr. Kelson Kawamura (CRM/PR 32174 · RQE 24787).
        </p>

        <h2 className="kk-h2">2. Encarregado pelo Tratamento de Dados (DPO)</h2>
        <p>
          O Encarregado é o próprio <strong>Dr. Kelson Kawamura</strong>. Contato para assuntos
          relacionados à privacidade e proteção de dados:{" "}
          <a href="mailto:drkelsonkawamura@gmail.com">drkelsonkawamura@gmail.com</a>.
        </p>

        <h2 className="kk-h2">3. Dados que coletamos</h2>
        <p>
          Este site não possui formulários de cadastro nem área logada. O agendamento de consultas
          é feito por WhatsApp. Quando você clica em &quot;Agendar consulta&quot;, é redirecionado
          ao WhatsApp, e a partir desse momento o tratamento dos dados ocorre na conversa direta com
          o consultório. Podem ser coletadas as seguintes informações conforme a sua iniciativa:
        </p>
        <ul>
          <li>Nome completo;</li>
          <li>Telefone / WhatsApp;</li>
          <li>E-mail (quando enviado por você);</li>
          <li>Informações de saúde que você optar por compartilhar para fins de agendamento e avaliação.</li>
        </ul>

        <h2 className="kk-h2">4. Finalidades do tratamento</h2>
        <ul>
          <li>Agendamento e gestão de consultas;</li>
          <li>Comunicação sobre atendimento, retornos e orientações;</li>
          <li>Cumprimento de obrigações legais, regulatórias e do Conselho Federal de Medicina (CFM).</li>
        </ul>

        <h2 className="kk-h2">5. Bases legais</h2>
        <p>
          O tratamento é realizado com base no consentimento do titular (art. 7º, I), execução de
          procedimentos preliminares a contrato (art. 7º, V), cumprimento de obrigação legal/regulatória
          (art. 7º, II) e tutela da saúde (art. 11, II, &quot;f&quot;).
        </p>

        <h2 className="kk-h2">6. Cookies e tecnologias de rastreamento</h2>
        <p>
          Atualmente este site <strong>não utiliza</strong> cookies de análise, publicidade ou
          rastreamento de terceiros. Caso esses recursos venham a ser ativados, esta Política será
          atualizada e será exibido um aviso de cookies para coleta de consentimento.
        </p>

        <h2 className="kk-h2">7. Compartilhamento de dados</h2>
        <p>
          Não vendemos dados pessoais. Os dados poderão ser compartilhados apenas com profissionais
          envolvidos no seu atendimento, com prestadores de serviços essenciais à operação
          (ex.: hospedagem e WhatsApp/Meta para comunicação) e quando exigido por autoridade
          competente ou obrigação legal.
        </p>

        <h2 className="kk-h2">8. Direitos do titular</h2>
        <p>Nos termos do art. 18 da LGPD, você pode solicitar a qualquer momento:</p>
        <ul>
          <li>Confirmação da existência de tratamento;</li>
          <li>Acesso, correção, anonimização ou eliminação dos dados;</li>
          <li>Portabilidade e revogação do consentimento;</li>
          <li>Informação sobre compartilhamentos.</li>
        </ul>
        <p>
          Para exercer seus direitos, escreva para{" "}
          <a href="mailto:drkelsonkawamura@gmail.com">drkelsonkawamura@gmail.com</a>.
        </p>

        <h2 className="kk-h2">9. Segurança e retenção</h2>
        <p>
          Adotamos medidas técnicas e administrativas para proteger seus dados. Prontuários e
          registros médicos são mantidos pelo prazo mínimo de 20 anos, conforme a Resolução CFM
          nº 1.821/2007.
        </p>

        <h2 className="kk-h2">10. Atualizações</h2>
        <p>
          Esta Política pode ser atualizada a qualquer tempo. A data da última atualização será
          sempre indicada abaixo.
        </p>

        <p style={{ marginTop: 32, fontSize: 13, color: "var(--kk-offwhite)" }}>
          Última atualização: {updated}.
        </p>

        <p style={{ marginTop: 24 }}>
          <Link to="/" className="kk-button-primary">Voltar para o início</Link>
        </p>
        </div>
      </div>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
